import { useState } from 'react';

import { Box, MenuItem, Select } from '@mui/material';

import { NewBackImage } from 'components/BackImage/BackImage';

import { useAppInfo } from 'hooks/useAppInfo/useAppInfo';

export function TestView() {
  const { data: appInfo } = useAppInfo();

  const [selected, setSelected] = useState('0');

  const selectedImage = appInfo?.background_images?.[+selected]?.image ?? undefined;

  return (
    <Box>
      <style>{`html { font-size: 16px !important; }`}</style>
      {appInfo !== undefined && (
        <Select<string>
          value={selected}
          onChange={(e) => {
            const { value } = e.target;
            setSelected(value);
          }}
        >
          {appInfo?.background_images.map((image, i) => {
            return (
              <MenuItem key={image.id} value={i.toString()}>
                {image.regex}
              </MenuItem>
            );
          })}
        </Select>
      )}

      <pre>{JSON.stringify(selectedImage, null, 2)}</pre>

      <NewBackImage src={selectedImage} />
    </Box>
  );
}
